export const CAMPAIGN_CREATE = 'CAMPAIGN_CREATE'
export const CAMPAIGN_DETAIL = 'CAMPAIGN_DETAIL'
